import styled from '@emotion/styled'
import { Color, Text, FontWeight } from '@vivaldis/ui'
import { DrawerFooterBarCompanyProps } from '../../typings/DrawerFooterBarCompanyProps'

export const Company = ({ name }: DrawerFooterBarCompanyProps) => {
  return (
    <Container>
      <Text
        fontSize={15}
        letterSpacing={0.33}
        lineHeight={20}
        fontWeight={FontWeight.Bold}
        color={Color.Text.Default}
        textClip="ellipsis"
      >
        {name}
      </Text>
    </Container>
  )
}

const Container = styled('div')`
  height: 32px;
  display: flex;
  align-items: center;
  overflow: hidden;
`
